<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
       
        <a-col :span="20">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品分类">
            <a-cascader placeholder="请选择产品分类" expandTrigger="hover" @change="categoryChange" :options="this.allCategory" v-decorator="['category',{initialValue:category,rules: [{ required: true, message: '请选择产品分类'}]}]"></a-cascader>
          </a-form-item>
        </a-col>       
      </a-row>
     
      <div class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  productName: "",
  productCode: "",
  specDes: "",
  productSeriesId: undefined,
  volume: "",
  weight: "",
  measureUnitId: undefined,
  expectedDelivery: ""
};
export default {
  name: "hp-manager-page-batch-edit",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    paramsB: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      productSeriesOptions: [],
      allCategory: [],
      measureUnitOptions: [],
      fileList: [],
      description: "",
      category: []
    };
  },

  async mounted() {
    this.getAllCategory();
    console.log(this.paramsB.productIdList);
  }, 
  methods: {
    cancel() {
      this.$emit("cancel");
    },   
    categoryChange(option) {
      this.data.firstCategoryId = parseInt(option[0]);
      if (option[1]) {
        this.data.sencondCategory = parseInt(option[1]);
      }
    },  
    async getAllCategory() {
      let categoryList = await api.GetAllProductCategoryForCascader();
      if (categoryList) {
        this.allCategory = categoryList;
      }
    },
    categoryChange(option) {
      this.data.firstCategoryId = parseInt(option[0]);
      if (option[1]) {
        this.data.sencondCategory = parseInt(option[1]);
      }
    },
   
    
    dataToPostData(value) {
      let result = {               
        categoryId: this.data.sencondCategory,
        ProductIdList:this.paramsB.productIdList
      };
      return result;
    },
    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        data = await api.BatchEditCategory(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        console.log(requestData);
      }
      this.loading = false;
    },    
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/Product/BatchEdit.vue